
// ROUTES
require('modules/invitation/routes/invitation');

// CONTROLLERS
require('modules/invitation/controllers/invitation');
require('modules/invitation/controllers/list');
require('modules/invitation/controllers/edit');
require('modules/invitation/controllers/search');
require('modules/invitation/controllers/tags');


// SERVICES
require('modules/invitation/services/invitation');
require('modules/invitation/services/list');
require('modules/invitation/services/create');
require('modules/invitation/services/edit');
require('modules/invitation/services/delete');
require('modules/invitation/services/check');



angular.module('unica_invitation', [

	// ROUTES
	'unica_invitation.invitation_routes',

	// CONTROLLERS
	'unica_invitation.invitation_controllers',

	// SERVICES
	'unica_invitation.invitation_services'

]);